import React from 'react';
//import LanguageDropdown from './LanguageDropdown';
import shelegLogin from '../api/shelegLogin';
import shelegApi from '../api/shelegApi';
import BackButton from './BackButton';
import langConf from "../js/lang";
import Select from 'react-select';

class Signup extends React.Component {
    constructor(props) {
        super(props);
        this.state = { selectedCityName: '', selectedStreetName: '' };
    }

    handleSignupClick = async (event) => {
        event.preventDefault();
        let lang = this.props.lang;
        if (await this.validateFields()) {
            window.alert(langConf[lang].userCreated);
            this.props.changePaymentMode('login');
        }
    };

    handleLogoClick = (event) => {
        event.preventDefault();
    };

    // When the user starts to type something inside the password field
    handlePasswordKeyup = async () => {
        var myInput = document.getElementById("signupPassword");
        var letter = document.getElementById("letter");
        var capital = document.getElementById("capital");
        var number = document.getElementById("number");
        var length = document.getElementById("length");
        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g;
        if (myInput.value.match(lowerCaseLetters)) {
            letter.classList.remove("invalid");
            letter.classList.add("valid");
        } else {
            letter.classList.remove("valid");
            letter.classList.add("invalid");
        }

        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g;
        if (myInput.value.match(upperCaseLetters)) {
            capital.classList.remove("invalid");
            capital.classList.add("valid");
        } else {
            capital.classList.remove("valid");
            capital.classList.add("invalid");
        }

        // Validate numbers
        var numbers = /[0-9]/g;
        if (myInput.value.match(numbers)) {
            number.classList.remove("invalid");
            number.classList.add("valid");
        } else {
            number.classList.remove("valid");
            number.classList.add("invalid");
        }

        // Validate length
        if (myInput.value.length >= 8) {
            length.classList.remove("invalid");
            length.classList.add("valid");
        } else {
            length.classList.remove("valid");
            length.classList.add("invalid");
        }
    }

    validatePassword = () => {
        var myInput = document.getElementById("signupPassword");
        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g;
        if (!myInput.value.match(lowerCaseLetters)) {
            return false;
        }

        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g;
        if (!myInput.value.match(upperCaseLetters)) {
            return false;
        }

        // Validate numbers
        var numbers = /[0-9]/g;
        if (!myInput.value.match(numbers)) {
            return false;
        }

        // Validate length
        if (!myInput.value.length >= 8) {
            return false;
        }
        return true;
    };

    handleKeyDown = async (e) => {
        //console.log('key: ', e.key);
        if (e.key === 'Enter') {
            if (await this.validateFields()) {
                window.alert(langConf[this.props.lang].userCreated);
                this.props.changePaymentMode('login');
            }
        }
    };

    validateId(idNumber) {
        var evenMultiplier = 1;
        var oddMultiplier = 2;
        var sum = 0;
        var thirdLine = [];
        var forthLine = [];
        if (idNumber.length <= 9 && idNumber.length > 7) {
            if (idNumber.length < 9) {
                while (idNumber.length < 9) {
                    idNumber = '0' + idNumber;
                }
            }
            for (let i = 0; i < idNumber.length; i++) {
                if (i % 2 === 0) {
                    thirdLine[i] = parseInt(idNumber[i]) * evenMultiplier;
                }
                else {
                    thirdLine[i] = parseInt(idNumber[i]) * oddMultiplier;
                }
            }
            for (let i = 0; i < thirdLine.length; i++) {
                if (thirdLine[i] > 9) {
                    forthLine[i] = parseInt(thirdLine[i]) / 10 + parseInt(thirdLine[i]) % 10;
                }
                else {
                    forthLine[i] = thirdLine[i];
                }
            }
            for (let i = 0; i < forthLine.length; i++) {
                sum += parseInt(forthLine[i]);
            }
            if (sum % 10 === 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };

    validateEmail(email) {
        //if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return true;
        }
        return false;
    };

    validatePhone(phone) {
        var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if ((phone.match(phoneno))) {
            return true;
        }
        else {
            return false;
        }
    };

    usernameAvailable = async (username) => {
        const pkg = {
            sesId: this.props.sessionId,
            contUserName: username
        }
        const response = await shelegLogin.post(`/UserExist`, pkg);
        if (!response.data.rslt) {
            return true;
        } else {
            return false;
        }
    };

    handleLoginClick = (event) => {
        event.preventDefault();
        this.props.changePaymentMode('login');
    };

    copyEmail = async () => {
        //let email = document.querySelector('#email').value;
        // document.querySelector('#signupUsername').value = email;
    };

    checkUserExistance = async (event) => {
        event.preventDefault();
        let lang = this.props.lang;
        let email = document.querySelector('#email').value;
        let mobile = document.querySelector('#mobile').value;
        let c = { Email: email, Mobile: mobile };
        const response = await shelegApi.post(`/GetContactDetailsFromDb/${this.props.sessionId}`, c);
        //console.log(response.data);

        if (response.data.contactNo !== '' && response.data.contUserName !== '') {
            if (window.confirm(langConf[lang].emailAlreadyInUse)) {
                this.props.changeExistingUsername(response.data.contUserName);
                this.props.changePaymentMode('login');
            }
        } else {
            document.querySelector('#signupUsername').value = c.Email;
        }
    };

    checkUsername = async (username) => {
        let lang = this.props.lang;
        if (username === '') {
            window.alert(langConf[lang].emptyUsername);
            return false;
        }
        if (!(await this.usernameAvailable(username))) {
            window.alert(langConf[lang].usernameUnavailable);
            return false;
        }
        return true;
    };

    handleCitySelected = async (event) => {
        await this.props.changeSelectedCity(event.value);
        await this.props.changeSelectedCityName(event.label);
        this.props.getStreets(this.props.selectedCity);
    };

    handleStreetSelected = async (event) => {
        await this.props.changeSelectedStreet(event.value);
        await this.props.changeSelectedStreetName(event.label);
    };

    validateFields = async () => {
        let lang = this.props.lang;
        let username = document.querySelector('#signupUsername').value;
        let password = document.querySelector('#signupPassword').value;
        let repeatPassword = document.querySelector('#signupRepeatPassword').value;
        let fullName = document.querySelector('#fullName').value;
        let idNo = document.querySelector('#idNo').value;
        let email = document.querySelector('#email').value;
        let mobile = document.querySelector('#mobile').value;
        let birthday = document.querySelector('#birthday').value;
        let city = this.props.selectedCityName; //document.querySelector('#city').value;
        let street = this.props.selectedStreetName; //document.querySelector('#street').value;
        let houseNo = document.querySelector('#address').value;

        let c = { Email: email };

        mobile = mobile.replace('-', '');
        email = email.toLowerCase();
        //username = username.search('@') !== -1 ? username.replace('@', '%40') : username;
        //let question = document.querySelector('#question').value;
        //let answer = document.querySelector('#answer').value;
        // console.log('username: ', username);
        // console.log('password: ', password);
        // console.log('fullName: ', fullName);
        // console.log('idNo: ', idNo);
        // console.log('email: ', email);
        // console.log('mobile: ', mobile);
        // console.log('birthday: ', birthday);
        //console.log('city: ', city);
        //console.log('street: ', street);
        // console.log('houseNo: ', houseNo);
        //console.log('question: ', question);
        //console.log('answer: ', answer);

        let userData = {
            contactName: fullName,
            userName: username,
            password: password,
            email: email,
            mobile: mobile,
            contIdNo: idNo,
            userHostAddress: '',
            userHostName: window.location.search,
            town: city,
            street: street + ' ' + houseNo,
            birthDate: birthday
        };


        let response = await shelegApi.post(`/ContactExist/${this.props.sessionId}`, c);

        if (username === '' || password === '' || repeatPassword === '' || email === '' || mobile === '' || fullName === '' || idNo === '' || city === '' || street === '' || houseNo === '') {
            window.alert(langConf[lang].emptySignup);
            return false;
        }
        if (!(await this.checkUsername(username))) {
            return false;
        }
        if (!this.validatePassword(password)) {
            window.alert(langConf[lang].illegalPassword);
            return false;
        }
        if (repeatPassword !== password) {
            window.alert(langConf[lang].passwordsMismatch);
            return false;
        }
        if (!this.validateId(idNo)) {
            window.alert(langConf[lang].errorId);
            return false;
        }
        if (response.data.rslt) {
            window.alert(langConf[lang].emailInUseError);
            return false;
        }
        if (!this.validateEmail(email)) {
            window.alert(langConf[lang].invalidEmail);
            return false;
        }
        if (!this.validatePhone(mobile)) {
            window.alert(langConf[lang].invalidMobile);
            return false;
        }

        //console.log('userData: ' ,userData);
        response = await shelegLogin.post(`CreateUser/${this.props.sessionId}`, userData);
        if (response.statusText === 'Created') {
            return true;
        }
        else if (response.statusText === 'InternalServerError' || response.statusText === 'BadRequest') {
            window.alert(langConf[lang].unexpectedError);
            return false;
        }
        return false;
    };

    render() {
        let lang = this.props.lang;
        let currentURL = this.props.currentURL;
        let isDisabled = false;
        // const cityList = this.props.cities.map((city) => { return <option key={city.cityCode} value={city.cityCode}>{city.cityName}</option>; });
        const cityList = this.props.cities.map((city) => { return { value: city.cityCode, label: city.cityName } });
        // const streetList = this.props.streets.map((street) => { return <option key={street.streetCode} value={street.streetCode}>{street.streetName}</option>; });
        const streetList = this.props.streets.map((street) => { return { value: street.streetCode, label: street.streetName } });
        return (
            <div className="row col-12 col-xs-12" style={this.props.visible === false ? { display: 'none' } : { marginRight: 'auto', marginLeft: 'auto' }}>
                <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 panel panel-info">
                    <div className="panel-heading" style={{ fontSize: '20px' }}>{langConf[lang].alreadyMember}<a href={currentURL} onClick={this.handleLoginClick}>{langConf[lang].loginHere}</a></div>
                    {/* <label className="credit-card" htmlFor="creditCardDetails" ><b style={{ fontSize: '2em' }}>{langConf[lang].alreadyMember}<a href={currentURL} onClick={this.handleLoginClick}>{langConf[lang].loginHere}</a></b></label> */}
                    <div id="personal" className="col-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group-lg panel-body" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                        <div className="col-4 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div className={`field full-name ${lang} signup-field`}>
                                <label className={`label full-name ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].fullName}</label>
                                <input
                                    id='fullName'
                                    type='text'
                                    className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}
                                    tabIndex="1"
                                    style={{ textAlign: 'right' }}
                                />
                            </div>
                        </div>
                        <div className="col-4 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div className={`field full-name ${lang} signup-field`}>
                                <label className={`label id-no ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].idNo}</label>
                                <input
                                    id='idNo'
                                    type='text'
                                    className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}
                                    tabIndex="2"
                                    style={{ textAlign: 'right' }}
                                />
                            </div>
                        </div>

                        <div className="col-4 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div className={`field email ${lang} signup-field`}>
                                <label className={`label email ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].email}</label>
                                <input
                                    id='email'
                                    type='email'
                                    className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}
                                    tabIndex="3"
                                    style={{ textAlign: 'right' }}
                                />
                            </div>
                        </div>
                        <div className="col-4 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div className={`field mobile ${lang} signup-field`}>
                                <label className={`label mobile ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].mobile}</label>
                                <input
                                    id='mobile'
                                    type='tel'
                                    className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}
                                    tabIndex="4"
                                    style={{ textAlign: 'right' }}
                                    onBlur={this.checkUserExistance}
                                />
                            </div>
                        </div>

                        <div className="col-4 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div className={`field birthday ${lang} signup-field`}>
                                <label className={`label birthday ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].birthDate}</label>
                                <input id='birthday' type='date' className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} tabIndex="5" style={{ textAlign: 'right' }}></input>
                            </div>
                        </div>
                        <div className={`col-4`}></div>
                        <div className={`col-12`}>
                            <div className="col-4 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                <label className={`label city ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].city}</label>
                                <Select placeholder={langConf[lang].selectCity} options={cityList} id='city' className={`selectpicker form-control input-lg col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} data-live-search="true" tabIndex="6" style={{ textAlign: 'right' }} onChange={this.handleCitySelected}></Select>
                            </div>
                            <div className="col-4 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                <label className={`label street ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].street}</label>
                                <Select placeholder={langConf[lang].selectStreet} options={streetList} id='street' className={`selectpicker form-control input-lg col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} tabIndex="7" style={{ textAlign: 'right' }} onChange={this.handleStreetSelected}></Select>
                            </div>
                            <div className="col-4 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                <div className={`field address ${lang} signup-field`}>
                                    <label className={`label address ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].houseNo}</label>
                                    <input id='address' type='text' className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} tabIndex="8" style={{ textAlign: 'right' }}></input>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className={`col-4 col-xs-0 col-sm-0 col-md-4 col-lg-4`}></div>
                            <div className={`col-4 col-xs-12 col-sm-12 col-md-4 col-lg-4 field signupUsername ${lang} signup-field`}>
                                <label className={`label signupUsername ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].username}</label>
                                <input
                                    id='signupUsername'
                                    ype='text'
                                    className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}
                                    tabIndex="9"
                                    style={{ textAlign: 'right' }}
                                    required />
                            </div>
                            <div className={`col-4 col-xs-0 col-sm-0 col-md-4 col-lg-4`}></div>
                        </div>
                        <div className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div className={`col-4 col-xs-0 col-sm-0 col-md-4 col-lg-4`}></div>
                            <div className={`col-4 col-xs-12 col-sm-12 col-md-4 col-lg-4 field signupPassword ${lang} signup-field`}>
                                <label className={`label signupPassword ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].password}</label>
                                <input
                                    id='signupPassword'
                                    type='password'
                                    className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}
                                    onKeyUp={this.handlePasswordKeyup}
                                    tabIndex="10"
                                    style={{ textAlign: 'right' }}
                                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                                    title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                                    required />
                            </div>
                            <div className={`col-4 col-xs-0 col-sm-0 col-md-4 col-lg-4`}></div>
                        </div>
                        <div id="message" className="col-12" style={{padding: '0px'}}>
                            <b>{langConf[lang].passwordMustContain}</b>
                            <b id="letter" className="invalid">{` ${langConf[lang].lowercase}, `}</b>
                            <b id="capital" className="invalid">{`${langConf[lang].uppercase}, `}</b>
                            <b id="number" className="invalid">{`${langConf[lang].number}, `}</b>
                            <b id="length" className="invalid">{langConf[lang].minEightCharacters}</b>
                        </div>
                        <div className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div className={`col-4 col-xs-0 col-sm-0 col-md-4 col-lg-4`}></div>
                            <div className={`col-4 col-xs-12 col-sm-12 col-md-4 col-lg-4 field signupPassword ${lang} signup-field`}>
                                <label className={`label signupPassword ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].repeatPassword}</label>
                                <input id='signupRepeatPassword' type='password' className={`form-control input-lg signup-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} tabIndex="11" style={{ textAlign: 'right' }}></input>
                            </div>
                            <div className={`col-4 col-xs-0 col-sm-0 col-md-4 col-lg-4`}></div>
                        </div>
                        <div className="col-6">
                            <BackButton lang={lang} currentURL={currentURL} onClick={(event) => { event.preventDefault(); this.props.changeScreen('finalOffer') }} tabIndex="13" />
                        </div>
                        <div className="col-6">
                            <a href={currentURL} className={`btn btn-success btn-block btn-lg ${isDisabled} signup-button ${lang}`} onClick={this.handleSignupClick} tabIndex="12" style={lang === 'hebrew' ? {} : {}}>{langConf[lang].signup}</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Signup;
